import {
  DefaultStackScreenOptions,
  OnboardingScreenPath,
} from "@/constants/Navigation";
import { Stack } from "@/crossPlatform/expo-router";
import useFeatureFlags from "@/hooks/useFeatureFlags";

const Layout = () => {
  const { isAddToCalendarEnabled } = useFeatureFlags();

  return (
    <Stack screenOptions={{ animation: "none" }}>
      <Stack.Screen
        name={OnboardingScreenPath.VerifyInformation}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={OnboardingScreenPath.Notifications}
        options={DefaultStackScreenOptions}
      />
      {isAddToCalendarEnabled && (
        <Stack.Screen
          name={OnboardingScreenPath.CalendarSync}
          options={DefaultStackScreenOptions}
        />
      )}
      <Stack.Screen
        name={OnboardingScreenPath.Consent}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={OnboardingScreenPath.Welcome}
        options={DefaultStackScreenOptions}
      />
    </Stack>
  );
};

export default Layout;
